import { useEffect, useRef, useState } from 'react';

export function useAsyncFeedback(updatedAt: number | undefined): boolean {
  const [showSuccess, setShowSuccess] = useState(false);
  const initialUpdatedAt = useRef(updatedAt);

  useEffect(() => {
    if (!updatedAt || updatedAt === initialUpdatedAt.current) {
      return;
    }
    setShowSuccess(true);
    const timer = setTimeout(() => setShowSuccess(false), 3000);
    return () => clearTimeout(timer);
  }, [updatedAt]);

  return showSuccess;
}
